// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

/** Haiti */
const HT: PhoneNumberData = [509, 'HT', 8, '00 00 0000'];

export default HT;
